export const NOT_AVAILABLE = 0;
export const AVAILABLE = 1;
export const SOLD_OUT = 2;
export const COMING_SOON = 3;
export const ENTRY_CLOSED = 4;



// WEBPACK FOOTER //
// ./app/src/components/EventHeader/BookNow/helpers/availabilityTypes.js